module.exports = __webpack_public_path__ + "static/media/jolene.ea12c527.png";